import SkinKey from "./SkinKey";

/**
 * SkinFactory keys are injected by various installers.
 * See AppInstaller.js etc
 */
const SkinFactory = {};
export default SkinFactory;

/**
 * Static method that returns a skin (DisplayObject) based on screen name
 * @param {SkinKey} key - Object with property 'skinClass'
 * @return {createjs.DisplayObject}
 */
SkinFactory.getSkin = function(key) {

    const skin = new key.skinClass();

    //Set skinType property for MediatorManager to spawn corresponding mediator
    skin.skinType = key;
    return skin;
};